import toastComponent from './toast.vue'
let ToastConstructor = null;
const showToast = (msg, time = 1500) => {
    const toastDom = new ToastConstructor({
        el: document.createElement('div'),
        data() {
            return {
                msg: msg,
                show: true
            }
        }
    });
    document.body.appendChild(toastDom.$el);
    setTimeout(() => {
        toastDom.show = false
    }, time);
};
export default {
    install(vue) {
        // 返回一个 扩展实例构造器
        ToastConstructor = vue.extend(toastComponent);
        // 注册为全局组件
        vue.prototype.$toast = showToast;
    }
}
